import React from 'react'
import { 
  Heart, 
  Palette, 
  Camera, 
  PaintBrush, 
  Sparkle, 
  MusicNote,
  PaintBucket,
  PencilSimple,
  PenNib,
  SquaresFour
} from 'phosphor-react'

// Icon mapping using Phosphor Icons with duotone style
export const categoryIcons: Record<string, React.ReactNode> = {
  'Volunteer': <Heart weight="duotone" className="w-5 h-5" color="#f5f5f5" />,
  'Volunteer Work': <Heart weight="duotone" className="w-5 h-5" color="#f5f5f5" />,
  'Volunteer & Community Design': <Heart weight="duotone" className="w-5 h-5" color="#f5f5f5" />,
  'Branding': <Palette weight="duotone" className="w-5 h-5" color="#f5f5f5" />,
  'Photography': <Camera weight="duotone" className="w-5 h-5" color="#f5f5f5" />,
  'Digital Art': <PaintBrush weight="duotone" className="w-5 h-5" color="#f5f5f5" />,
  'Painting': <PaintBucket weight="duotone" className="w-5 h-5" color="#f5f5f5" />,
  'Drawing & Illustration': <PencilSimple weight="duotone" className="w-5 h-5" color="#f5f5f5" />,
  'Writing': <PenNib weight="duotone" className="w-5 h-5" color="#f5f5f5" />,
  'Design': <SquaresFour weight="duotone" className="w-5 h-5" color="#f5f5f5" />,
  'Education': <Sparkle weight="duotone" className="w-5 h-5" color="#f5f5f5" />,
  'Creative Tech': <MusicNote weight="duotone" className="w-5 h-5" color="#f5f5f5" />
}
